@if (operationSegmentSpec$ | async; as operation) {
  <elder-basic-pane-layout class="full">
    <elder-pane class="flex-30">
      <elder-pane-content>
        <!-- Instruction selection -->
        <elder-table
          class="flex"
          [data]="instructionSpecs$ | async"
          [selectionMultiEnabled]="true"
          [selectionVisible]="true"
          (itemClick)="selectedInstructionSpec = $event"
        >
          <elder-data-toolbar
            *elderTableToolbar
            [canMore]="false"
            [canAdd]="true"
            [canRemove]="true"
            (requestNew)="onNewInstructionSpec($event)"
            (requestRemove)="onRemoveInstructionSpecs($event)"
          >
          </elder-data-toolbar>
          <!-- id -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>{{ 'context.name' | translate }}</th>
            <td mat-cell *matCellDef="let instr">{{ instr.taskName }}</td>
          </ng-container>
          <!-- order controls -->
          <ng-container matColumnDef="actionOrder">
            <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
            <td mat-cell *matCellDef="let op">
              <div class="place-start-center">
                <button mat-icon-button (click)="moveUp(op)" elderStopEventPropagation>
                  <mat-icon>arrow_drop_up</mat-icon>
                </button>
                <button mat-icon-button (click)="moveDown(op)" elderStopEventPropagation>
                  <mat-icon>arrow_drop_down</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>
        </elder-table>
      </elder-pane-content>
    </elder-pane>
    <!-- Instruction detail view -->
    <app-instruction-detail
      class="flex"
      [instruction]="selectedInstructionSpec$ | async"
      (save)="onSave($event)"
    >
    </app-instruction-detail>
  </elder-basic-pane-layout>
}
